import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useTaskResourceIncrementCount } from 'packages/workspace/modules/datastores/omnichannel/useChannelResources';
import { taskRouterStore } from 'packages/workspace/services/store/omnichannel/taskrouter-store';

interface TypeActionProps {
  message: string | undefined;
  helper_text: string | undefined;
  sender: string | undefined;
  userId: string | undefined;
  dateTime?: string | Date;
  display_name: string;
  msgClass: string;
  action_owner: string;
  entity_id: string;
  app_id?: string;
  task_sid?: string;
}
const TypeAction: React.FC<TypeActionProps> = ({ sender, userId, dateTime, display_name, msgClass, action_owner, entity_id, app_id, task_sid, message = '', helper_text = '' }) => {
  const { mutateAsync: mutateResourceIncrementCount } = useTaskResourceIncrementCount();

  const sendToActiveChat = () => {
    mutateResourceIncrementCount(
      {
        app_id: app_id,
        task_sid: task_sid,
        document_id: entity_id,
        name: message,
      },
      {
        onSuccess: () => {
          taskRouterStore.useResourceFromButton(helper_text);
        },
      }
    );
  };

  return (
    <>
      <div className={sender === userId ? 'text-right text-xs text-tc-4' : 'text-left text-xs text-tc-4'}>
        {sender === userId ? (
          <>
            <strong>{display_name}</strong> {dateTime}
          </>
        ) : (
          <>
            {dateTime} <strong> {display_name}</strong>
          </>
        )}
      </div>
      {action_owner === userId ? (
        <Tooltip title={helper_text}>
          <Button className="button-primary button-full my-5" onClick={() => sendToActiveChat()}>
            {message}
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title={helper_text}>
          <div
            className={
              sender === userId
                ? 'text-right bg-tc-4 text-tc-1 rounded-tr-none py-1 px-4 rounded-2xl breakWord'
                : 'text-left text-tc-2  rounded-tl-none py-1 px-4 rounded-2xl breakWord' + ` ${msgClass}`
            }
          >
            {message}
          </div>
        </Tooltip>
      )}
    </>
  );
};

export default TypeAction;
